/**
 * Token storage（CMS namespace；與 PWA storage 隔離）。
 *
 * v1：access_token 暫存 localStorage（XSS 風險已知）。
 * 後續 (M2+) 遷移：
 *   - access_token 留 in-memory
 *   - refresh_token httpOnly cookie
 */

const STORAGE_KEY = 'boat.cms.access_token';
const LOGOUT_EVENT = 'boat:cms:auth:logout';

export function storeAccessToken(token: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // ignore
  }
}

export function getAccessToken(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearAccessToken(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(LOGOUT_EVENT));
  }
}

export function isAuthenticated(): boolean {
  return Boolean(getAccessToken());
}

export const AUTH_EVENT = {
  LOGOUT: LOGOUT_EVENT,
} as const;
